<template>
  <a-modal v-model="isShow" :title="title">
    <a-auto-complete v-model="value" :data-source="dataSource" style="width: 100%" :placeholder="text"
      @select="onSelect" @search="onSearch" @change="onChange" />
  </a-modal>
</template>

<script>
import axios from "axios";

export default {
  props: {
    selected: { type: Function },
    title: String,
  },
  components: {},
  data() {
    return {
      text: "พิมพ์ชื่อเพื่อค้นหา",
      isShow: false,
      value: "",
      dataSource: [],
      map: new Map()
    };
  },
  //
  //
  //
  mounted() {

  },
  //
  //
  //
  methods: {
    show() {
      this.value = "";
      this.dataSource = [];
      this.isShow = true;
    },
    //
    //
    //
    onSearch(value) {
      axios
        .get(
          process.env.VUE_APP_INVENTORY_API +
          "/group-whitelists/search?q=" +
          value,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          }
        )
        .then(response => {
          let data = [];
          for (let i = 0; i < response.data.data.length; i++) {
            const name = response.data.data[i].name;
            if (name === undefined) continue;
            if (data.includes(name)) continue;
            data.push(name);
          }
          this.dataSource = data;

          // Build data list for autosuggestion
          this.map.clear();
          for (let i = 0; i < data.length; i++) {
            this.map.set(
              response.data.data[i].name,
              response.data.data[i]
            );
          }
        })
        .catch(error => {
          this.$notification.open({
            message: "Notification",
            description: error.response.data.message,
            icon: <a-icon type="close-circle" style="color: #FF0000" />
          });
          return;
        });
    },
    //
    //
    //
    onSelect(value) {
      // Convert name to username
      this.isShow = false;
      this.selected(this.map.get(value));
    },
    //
    //
    //
    onChange(value) {
      // console.log('onchange', value);
    }
  }
};
</script>

<style lang="scss"></style>
